import Main from './Main'

const SubscriptionCompany = {
  Main,
}

export default SubscriptionCompany
